<template>
    <div class="recommendations-page">
        <div class="recommendations-page__content">
            <TabsComponent
                v-model="selectedTab"
                :tabs="tabs"
                :action-button="{
                    onClick: () => openAddRecommendation(selectedTab),
                    icon: 'plus',
                    text: t('admin.recommendationTypes.recommendationModal.title.add')
                }"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useConditionStatusAddRecommendationTypeModal } from '@/pages/admin/recommendation-types/modal/add-recommendation/useConditionStatusAddRecommendationTypeModal'
import { TabItems } from '@/components/tabs/TabItems'
import TabsComponent from '@/components/tabs/TabsComponent.vue'
import { defineAsyncComponent, ref } from 'vue'
import { ComponentType } from '@/configuration/component/component-types'

const { t } = useI18n()
const { openAddRecommendation } = useConditionStatusAddRecommendationTypeModal()
const defaultTab = ComponentType.Transformer
const selectedTab = ref(defaultTab)

const tabs: TabItems = [
    {
        titleKey: 'navigation.sidebar.transformers',
        key: ComponentType.Transformer,
        tabComponent: defineAsyncComponent(() => import('@/pages/admin/recommendation-types/RecommendationTypesTableSection.vue')),
    },
    {
        titleKey: 'navigation.sidebar.generators',
        key: ComponentType.Generator,
        tabComponent: defineAsyncComponent(() => import('@/pages/admin/recommendation-types/RecommendationTypesTableSection.vue')),
    },
]
</script>

<style scoped lang="scss">
.recommendations-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__header {
        @include spacing-page;

        display: flex;
        flex-direction: column;
        gap: $spacing-m;

        background-color: $pbl-foreground;
        border-bottom: 1px solid $pbl-border-muted;

        &__title {
            font-size: 1.25rem;
            font-weight: 500;
        }
    }

    &__content {
        @include spacing-page;
        overflow-y: scroll;

        &__add {
            display: flex;
            justify-content: flex-end;
            padding-bottom: 10px;
        }

        &__table {
            display: flex;
            flex-direction: column;

            gap: $spacing-m;
        }

        &__empty-state {
            padding: 50px 0;

            display: flex;
            flex-direction: column;

            align-items: center;
            justify-content: center;
            gap: $spacing-s;

            color: $pbl-text-muted;

            pbl-icon {
                --size: 2rem;
            }

            span {
                font-weight: 500;
                font-size: 1.25rem;
            }
        }
    }
}
</style>
